import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/api'
Vue.use(Vuex)
function storeLocalStore (state) {
    window.localStorage.setItem("sfyStorage",JSON.stringify(state));
}
const state = {
    token:'',
    userInfo:{},
    openId:'',
    currentMemorialId:'',
    userMemorialId:'',
    currentMenuIndex:0
}

export default new Vuex.Store({
    state,
    mutations:{
        saveOpenId(state, openId) {
            state.openId = openId
            storeLocalStore(state)
        },
        saveToken(state,token){
            state.token=token
            // storeLocalStore(state)
        },
        saveUserInfo(state, data) {
            state.userInfo = data
            console.log('mutations_state:',state)
            storeLocalStore(state)
        },
        saveUserMemorialId(state, id) {
            state.userMemorialId = id
            console.log('saveUserMemorialId:',id)
            storeLocalStore(state)
        },
        setCurrentMemorialId(state,id){
            Vue.set(state,'currentMemorialId',id)
            // storeLocalStore(state)
        },
        setCurrentMenuIndex(state,index){
            Vue.set(state,'currentMenuIndex',index)
        }
    },
    actions:{
        saveUserInfo({commit},user){
            commit('saveUserInfo',user)
        },
        logout({commit}){
            console.log('logout')
            commit('saveToken','')
            commit('saveUserMemorialId','')
            commit('setCurrentMemorialId','')
            commit('saveUserInfo','')
        },
        loginSuccess({commit},data){
            console.log('登录成功：',data)
            commit('saveToken',data.token)
            commit('saveUserMemorialId',data.extend?data.extend.memorialId:'')
            commit('saveUserInfo',data)
        }
    }
})
